import axios from "axios"

axios.interceptors.request.use(function (config) {
    const tokennn = localStorage.getItem('access-token')
    if (tokennn) {
        config.headers.Authorization = 'Bearer ' + tokennn;
        config.headers['If-None-Match'] = '';
    }
    return config;
})